import * as systemConstants from '../../constants/systemConstants';

const INITIAL_STATE = {
  auth: {},
  errorMessage: '',
  redirectTo403: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case systemConstants.LOGIN_SUCCESS:
      return { ...state, auth: action.payload, errorMessage: '' };
    case systemConstants.LOGIN_FAILURE:
      return { ...state, errorMessage: action.payload };
    case systemConstants.RESET_ERROR_MESSAGE:
      return { ...state, errorMessage: '' };
    case systemConstants.REDIRECT_PATH_LOGIN:
      return { ...state, redirectToLogin: true };  
    case systemConstants.REDIRECT_TO_FORBIDDEN: 
      return { ...state, redirectTo403: true };  
    case systemConstants.RESET_REDIRECT_FORBIDDEN: 
      return { ...state, redirectTo403: false };    
    default:
      return state;
  }
};
